import { render, staticRenderFns } from "./SectionHead.vue?vue&type=template&id=212c215a&scoped=true"
import script from "./SectionHead.vue?vue&type=script&lang=js"
export * from "./SectionHead.vue?vue&type=script&lang=js"
import style0 from "./SectionHead.vue?vue&type=style&index=0&id=212c215a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212c215a",
  null
  
)

export default component.exports